import { render, staticRenderFns } from "./PrintLayoutHeader.vue?vue&type=template&id=5f21560a&"
import script from "./PrintLayoutHeader.vue?vue&type=script&lang=js&"
export * from "./PrintLayoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrintLayoutHeader.vue?vue&type=style&index=0&id=5f21560a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports